import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineRoadmap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.517}
      d="m21.35 25.944 3.675-3.675-3.675-3.675M13.081 4.813h7.58a4.364 4.364 0 0 1 0 8.728h-2.067M13.081 13.54H7.34a4.364 4.364 0 0 0 0 8.729h.23M2.975 4.813h4.594M13.081 22.269h11.944"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.517}
      d="M7.569 4.812a2.756 2.756 0 1 0 5.512 0 2.756 2.756 0 0 0-5.512 0M7.569 22.269a2.756 2.756 0 1 0 5.512 0 2.756 2.756 0 0 0-5.512 0M13.081 13.54a2.756 2.756 0 1 0 5.513 0 2.756 2.756 0 0 0-5.513 0"
    />
  </svg>
);
export default SvgStreamlineRoadmap;
